import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import Box from "@mui/material/Box";
import moment from "moment";
import "moment-timezone";
import { useEffect, useState } from "react";
import React from "react";
import latlngMarker from "../../assets/latlng_marker.png";
import truck from "../../assets/caminhao.png";
import "./style.css";
import { TrackerRelationshipsService } from "../../services/trackerRelationships";

moment.tz.setDefault("America/Sao_Paulo");

export const Maps = ({
  height,
  latLong,
  latLongAndPlateSelected,
  trackerRelationshipsId,
  isLoadPoints,
}) => {

  const [markers, setMarkers] = useState([]);
  const [positionsTrackerRelationShipId, setPositionsTrackerRelationShipId] = useState([]);
  const [isLoadPositions, setIsLoadPositions] = useState(false);
  const [previousPlate, setPreviousPlate] = useState('');
  const trackerRelationshipsService = new TrackerRelationshipsService();
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    setMap(map);

  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100vw",
    height: height,
  };

  useEffect(() => {
    if (map && window.google) {
      markers.forEach((marker) => marker.setMap(null));
      setMarkers([]);

      if (latLongAndPlateSelected !== null) {
        if (latLongAndPlateSelected.plate !== previousPlate) {
          setPreviousPlate(latLongAndPlateSelected.plate);
          setIsLoadPositions(false);
        }
      }

      if (isLoadPositions === false) {
        if (latLongAndPlateSelected !== null) {
          const latLongSelected = {
            lat: latLongAndPlateSelected.lat,
            lng: latLongAndPlateSelected.lng,
          };
          map.setZoom(18);
          map.setCenter(latLongSelected);

          trackerRelationshipsService
            .getLatLong(trackerRelationshipsId)
            .then((response) => {
              setPositionsTrackerRelationShipId(response.data);
              setIsLoadPositions(true);
              isLoadPoints(true);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const bounds = new window.google.maps.LatLngBounds();
          latLong.forEach((marker) => {
            bounds.extend(new window.google.maps.LatLng(marker.lat, marker.lng));
          });
          map.fitBounds(bounds);

        }
      }
      const infoWindow = new window.google.maps.InfoWindow();
      if (positionsTrackerRelationShipId.length > 0) {
        // Add new markers
        const newMarkers = positionsTrackerRelationShipId?.map((latlng, i) => {
          const marker = new window.google.maps.Marker({
            position: latlng,
            map,
            optimized: true,
            icon: {
              url: latlngMarker,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(0, 10),
              scaledSize: new window.google.maps.Size(6, 6),
            },
          });
          marker.addListener("mouseover", () => {
            marker.setIcon({
              url: latlngMarker,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(0, 10),
              scaledSize: new window.google.maps.Size(18, 18),
            });
            infoWindow.setOptions({
              minWidth: 200,
            });
            infoWindow.close();
            const ignition = latlng.ignition ? "ON" : "OFF";
            const door = latlng.isDoorOpen ? "Fechada" : "Aberta";
            const thermoKing =
              latlng.thermoKing === "ON"
                ? "ON"
                : latlng.thermoKing === "OFF"
                  ? "OFF"
                  : "OFF/ALRM";
            infoWindow.setZIndex(100);
            infoWindow.setContent(`
               <style>
                .row {
                  display: flex;
                  background-color: rgb(72, 120, 86) !important;
                }
                .column {
                  padding: 5px;
                }
              </style>
              <div class="row">
                  <div class="column"> 
                    <p style="color:white; font-weight:800; font-size:11px;" >
                      ${moment(latlng.dateTimeLastUpdate).format(
              "DD/MM/YYYY, HH:mm:ss"
            )}
                      ,
                      ${latlng.vehicleSpeed} km/h
                    </p>

                    <p style="color:white; font-weight:800; font-size:11px;" }}>
                      IGN: <span style="color:white; font-weight:500; font-size:12px;">${ignition}</span>
                      , P: <span style="color:white; font-weight:500; font-size:12px;">${door}</span>
                      , C: <span style="color:white; font-weight:500; font-size:12px;">${thermoKing}</span>
                    </p>

                    <p style="color:white; font-weight:800; font-size:11px;" >
                      BAT (V,B): <span style="color:white; font-weight:500; font-size:12px;">${latlng.powerVoltage
              }, ${latlng.trunkVoltage} V</span>
                    </p>
                   
                    <p style="color:white; font-weight:800; font-size:11px;" >
                      TEMP (E, I1, I2): <span style="color:white; font-weight:500; font-size:12px;">${latlng.temperatureExt
              }, ${latlng.temperatureInt1}, ${latlng.temperatureInt2
              } ºC</span>
                    </p>

                    <p style="color:white; font-weight:800; font-size:11px;" >
                      UMID (I1, I2): <span style="color:white; font-weight:500; font-size:12px;">${latlng.humidity1
              }, ${latlng.humidity2} %</span>
                    </p>

                    <p style="color:white; font-weight:800; font-size:11px;" >
                      CO2: <span style="color:white; font-weight:500; font-size:12px;">${latlng.firstCo2
              } PPM , VIB: ${latlng.vibration1} G</span>
                    </p>

                    <p style="color:white; font-weight:800; font-size:11px;" >
                      LAT/LONG: <span style="color:white; font-weight:500; font-size:12px;">${latlng.lat
              }, ${latlng.lng}</span>
                    </p>
                  </div>
                  </div>
              </div>
              
              `);
            infoWindow.open(marker.getMap(), marker);
          });

          marker.addListener("mouseout", () => {
            infoWindow.close();
            marker.setIcon({
              url: latlngMarker,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(0, 10),
              scaledSize: new window.google.maps.Size(6, 6),
            });
          });

          return marker;
        });
        setMarkers(newMarkers);
      }
    }

  }, [map, latLongAndPlateSelected, positionsTrackerRelationShipId, isLoadPositions, latLong]);

  
  let mapOptions = {}
  if (window.google?.maps.ControlPosition) {
    mapOptions = {
      zoomControl: true,
      zoomControlOptions: {
        position: window.google?.maps?.ControlPosition.LEFT_BOTTOM,
      },
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: true,
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: window.google?.maps?.ControlPosition.BOTTOM_LEFT,
      },
      mapTypeId: "roadmap",
      minZoom: 3,
      maxZoom: 30,
    };
  }


  return (
    <Box style={{ height: "100%" }}>
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={mapOptions}

        >
          {latLongAndPlateSelected === null ? (
            latLong?.map((latlng, i) => {
              let position = { lat: latlng.lat, lng: latlng.lng };
              try {
                return (
                  <Marker
                    key={`track-${i + 1}`}
                    title={"Posição do Veículo"}
                    position={position}
                    icon={{
                      url: truck,
                    }}
                  >
                    <InfoWindow
                      position={position}
                      options={{
                        minWidth: 130,
                        pixelOffset: new window.google.maps.Size(0, -50),
                        disableAutoPan: true,
                      }}
                    >
                      <div>
                        <p
                          style={{
                            color: "white",
                            fontSize: "20px",
                            fontWeight: "700",
                          }}
                        >
                          {latlng.plate}
                        </p>
                      </div>
                    </InfoWindow>
                  </Marker>
                );
              } catch (error) {
                console.error(error);
              }
            })
          ) : (
            <Marker
              key={`track-selected`}
              title={"Posição do Veículo"}
              position={{
                lat: latLongAndPlateSelected.lat,
                lng: latLongAndPlateSelected.lng,
              }}
              icon={{
                url: truck,
              }}
            >
              <InfoWindow
                position={{
                  lat: latLongAndPlateSelected.lat,
                  lng: latLongAndPlateSelected.lng,
                }}
                options={{
                  minWidth: 130,
                  pixelOffset: new window.google.maps.Size(0, -50),
                  disableAutoPan: true,
                }}
              >
                <div>
                  <p
                    style={{
                      color: "white",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    {latLongAndPlateSelected.plate}
                  </p>
                </div>
              </InfoWindow>
            </Marker>
          )}
          <></>
        </GoogleMap>
      ) : (
        <></>
      )}
    </Box>
  );
};
